import { ColumnDef } from "@tanstack/react-table";

import { Report1SchemaType } from "./schema";
// import { DataTableRowActions } from "./data-table-row-actions";
import { DataTableColumnHeader } from "./data-table-column-header";

export const columns: ColumnDef<Report1SchemaType, any>[] = [
  {
    id: "index",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Index" />
    ),
    cell: ({ row }) => <div className="w-[80px]">{row.index + 1}</div>,
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "employee",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Name" />
    ),
    cell: ({ row }) => (
      <div>
        <div className="hover:underline">{row.getValue("employee")}</div>
      </div>
    ),
    enableColumnFilter: true,
  },
  {
    accessorKey: "alloted",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Alloted" />
    ),
    cell: ({ row }) => <div>{row.getValue("alloted")}</div>,
  },
  {
    accessorKey: "attempted",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Attempted" />
    ),
    cell: ({ row }) => <div>{row.getValue("attempted")}</div>,
  },
  {
    accessorKey: "success",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Success" />
    ),
    cell: ({ row }) => <div>{row.getValue("success")}</div>,
  },
  {
    accessorKey: "failed",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Failed" />
    ),
    cell: ({ row }) => <div>{row.getValue("failed")}</div>,
  },
  {
    accessorKey: "open",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Open" />
    ),
    cell: ({ row }) => <div>{row.getValue("open")}</div>,
  },

  // {
  //   id: "actions",
  //   cell: ({ row }) => <DataTableRowActions row={row} />,
  // },
];
